import React from "react";
import { Seeker } from "../../types/seeker";
import SeekerProfileHeader from "./SeekerProfileHeader";
import SeekerSurveyResults from "./SeekerSurveyResults";
import SeekerOnboardingProgress from "./SeekerOnboardingProgress";
import SeekerSessionHistory from "./SeekerSessionHistory";
import { ScheduledSession } from "../../data/sessionService";
import { Notes } from "../Notes";

interface SeekerMainContentProps {
    seeker: Seeker;
    sessions: ScheduledSession[];
    loadingSessions: boolean;
    sessionsError: string | null;
}

export default function SeekerMainContent({
    seeker,
    sessions,
    loadingSessions,
    sessionsError,
}: SeekerMainContentProps) {
    return (
        <div className="flex w-full max-w-[38rem] flex-col gap-6">
            <SeekerProfileHeader seeker={seeker} />
            <SeekerSurveyResults seeker={seeker} />
            <SeekerOnboardingProgress seeker={seeker} />
            <SeekerSessionHistory
                seeker={seeker}
                sessions={sessions}
                loadingSessions={loadingSessions}
                sessionsError={sessionsError}
            />
            {seeker.userId && (
                <Notes
                    subjectId={seeker.userId}
                    subjectType="seeker"
                    subjectName={seeker.name || "Seeker"}
                />
            )}
        </div>
    );
}
